import React, { useEffect, useState } from 'react';
import '../styles/login.css';
import Task_Scheduler from '../styles/AI-Task_Scheduler.png';
import AnimatedSkills from "./skills.animation";
import manzil from '../styles/Manzil.png';
import SnackOutLogo from "../styles/snack-out.svg"
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@radix-ui/react-tabs'; // Example import, adjust based on your library
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Profile photo lives in /public so it can be swapped without a rebuild
const ProfilePic = `${process.env.PUBLIC_URL}/Graduate.jpeg`;

const MainPage = () => {
    // Dynamic date rendered in Urdu (Pakistan locale)
    const todayDate = new Date().toLocaleDateString('ur-PK', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });

    const [musicOn, setMusicOn] = useState(false);
    const audioRef = React.useRef(null);

    const toggleMusic = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = 0.35;
        if (audio.paused) {
            audio.play().catch((err) => console.warn('Audio play failed:', err));
        } else {
            audio.pause();
        }
    };

    // Keep the button label in sync with the audio's ACTUAL state,
    // no matter what starts/stops it. This is the source of truth.
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        const onPlay = () => setMusicOn(true);
        const onPause = () => setMusicOn(false);
        audio.addEventListener('play', onPlay);
        audio.addEventListener('pause', onPause);
        audio.addEventListener('ended', onPause);
        return () => {
            audio.removeEventListener('play', onPlay);
            audio.removeEventListener('pause', onPause);
            audio.removeEventListener('ended', onPause);
        };
    }, []);

    // Browsers block autoplay until the user interacts with the page.
    // Try to start the music on the first gesture (but ignore clicks on the
    // music button itself, so it never fights the toggle).
    useEffect(() => {
        const startOnFirstGesture = (e) => {
            if (e && e.target && e.target.closest && e.target.closest('.music-toggle')) {
                return; // let the button's own handler decide
            }
            const audio = audioRef.current;
            if (audio && audio.paused) {
                audio.volume = 0.35;
                audio.play().catch(() => {});
            }
            cleanup();
        };
        const cleanup = () => {
            window.removeEventListener('pointerdown', startOnFirstGesture);
            window.removeEventListener('keydown', startOnFirstGesture);
            window.removeEventListener('scroll', startOnFirstGesture);
        };
        window.addEventListener('pointerdown', startOnFirstGesture);
        window.addEventListener('keydown', startOnFirstGesture);
        window.addEventListener('scroll', startOnFirstGesture);
        return cleanup;
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [hasScrolledToProjects, setHasScrolledToProjects] = useState(false)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

const handleSubmit = (e) => {
    e.preventDefault();
    fetch('https://portflio-website-ufkd.vercel.app/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then(data => {
        console.log(data);
        setFormData({ name: '', email: '', message: '' }); // Reset the form
        toast.success('Message sent successfully!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
                backgroundColor: 'white', // White background
                color: 'Black',        // Navy blue text
                fontWeight: 'bold',
                borderRadius: '8px',
                border: '2px solid white' // optional: add border to make it visible
            },
            icon: '🚀'
        });

    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        toast.error('Failed to send message. Please try again later.', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
                backgroundColor: 'white', 
                color: 'black',
                fontWeight: 'bold',
                borderRadius: '8px'
            },
            icon: '⚠️'
        });
    });
};


    useEffect(() => {
        const handleScroll = () => {
            const projectsSection = document.getElementById('projects');
            const sectionPosition = projectsSection.getBoundingClientRect().top;
            const screenHeight = window.innerHeight;

            if (sectionPosition < screenHeight && !hasScrolledToProjects) {
                setHasScrolledToProjects(true); 
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [hasScrolledToProjects]);

    return (
        <>
            <div className="header-about-container">
                <header>
                    <h1>Muhammad Mehdi</h1>
                    {/* <p className="masthead-urdu" lang="ur" dir="rtl">
                        مجھے مزید جاننے کے لیے میرا پروفائل ملاحظہ کریں
                    </p> */}
                    
                    <div className="masthead-meta" dir="rtl" lang="ur">
                        <span>جلد ۲۵ · شمارہ ۱</span>
                        <span>{todayDate}</span>
                        <span>لاہور · پاکستان ایڈیشن</span>
                    </div>
                    <nav>
                        <ul>
                            <li><a href="#about">Front Page</a></li>
                            <li><a href="#projects">Featured Work</a></li>
                            <li><a href="#skills">Toolbox</a></li>
                            <li><a href="#experience">Career</a></li>
                            <li><a href="#contact">Letters</a></li>
                        </ul>
                    </nav>
                </header>

                <section id="about" className="about-section">

                    <div className="about-lead">
                        <div className="about-card">
                            <p>
                                Muhammad Mehdi is a <span className="highlighted">Full Stack AI Engineer at FireBirdTech</span>, where he builds{' '}
                                <a className="inline-link" href="https://blog2video.app" target="_blank" rel="noopener noreferrer">Blog2Video</a>{' '}
                                — a platform that turns a written blog into a ready-to-publish video in a few clicks. With prior roles at <span className="highlighted">Syscov</span> and <span className="highlighted">SnackOut Technologies</span>, he has shipped scalable web and mobile products end to end — from clean API design to polished, responsive interfaces. His expertise spans <span className="highlighted">MERN</span>, <span className="highlighted">React Native</span>, <span className="highlighted">AWS</span>, and infrastructure-as-code, and he cares deeply about user experience, performance, and maintainable systems. He holds a <span className="highlighted">BS in Computer Science</span> from <span className="highlighted">LUMS</span> and is always keen to build things that reach real users.
                            </p>
                        </div>

                        <div className="about-portrait">
                            <div className="profile-pic-container">
                                <img src={ProfilePic} alt="Muhammad Mehdi" className="profile-pic" />
                            </div>
                            <div className="profile-caption">Muhammad Mehdi · Software Engineer</div>
                            <p className="masthead-urdu masthead-urdu-sub" lang="ur" dir="rtl">
                                پاکستان کی صفِ اول کی جامعہ، لمز سے فارغ التحصیل
                            </p>
                        </div>
                    </div>

                    <div className="social-icons">
                        <a href="https://www.linkedin.com/in/muhammad-mehdi-07a716255" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-linkedin" />
                        </a>
                        <a href="https://github.com/Muhammad-Mehdi-Changazi" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-github"></i>
                        </a>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <a href="https://drive.google.com/file/d/1RggIoG-rVdFxMEU0lNeL8wPBBzpkYgME/view?usp=sharing" download="Muhammad_Mehdi_CV" className="btn-download-cv">Download Résumé</a>
                    </div>
                </section>
            </div>

{/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
           
      <section id="projects" className="projects-section">
            <div className={`container ${hasScrolledToProjects ? 'slide-in' : ''}`}>
                <div className="masthead-rule">
                    <h2 className="section-headline">Featured Work</h2>
                    <div className="section-kicker">Special Reports · Selected Projects</div>
                </div>

                  <Tabs defaultValue="blog2video" style={{ marginTop: '10px' }}>
                    <TabsList className="tab-buttons-container">
                        <TabsTrigger value="blog2video" className="tab-button">
                        Blog2Video
                        </TabsTrigger>
                        <TabsTrigger value="eventmgmt" className="tab-button">
                        Event Platform
                        </TabsTrigger>
                        <TabsTrigger value="Manzil" className="tab-button">
                        JourniSphere
                        </TabsTrigger>
                        <TabsTrigger value="taskscheduling" className="tab-button">
                        AI Scheduler
                        </TabsTrigger>
                        <TabsTrigger value="awschatbot" className="tab-button">
                        AWS Chatbot
                        </TabsTrigger>
                    </TabsList>

                {/* Blog2Video — Featured */}
                <TabsContent value="blog2video">
                    <div className="project-card" style={{ marginTop: '20px' }}>
                    <div className="text-section">
                        <h3>Blog2Video — AI Content-to-Video Pipeline</h3>
                        <div className="project-byline">FireBirdTech · In Production · 2026 —{' '}
                            <a className="inline-link" href="https://blog2video.app" target="_blank" rel="noopener noreferrer">blog2video.app</a>
                        </div>
                        <p>
                        Blog2Video is a production AI platform that transforms written content into fully rendered videos automatically. I engineered the content-to-video pipeline using <span className="highlighted">DSPy</span> to orchestrate the language-model reasoning that turns a blog post into a scripted, scene-by-scene storyboard, enabling scalable, automated video generation for real users. I designed and implemented robust API integrations and backend workflows that power high-performance AI processing across the system, and built and optimized dynamic video UI templates with <span className="highlighted">Remotion</span>, improving rendering efficiency, customization capabilities, and the overall user experience.
                        </p>
                        <a className="project-link" href="https://blog2video.app" target="_blank" rel="noopener noreferrer">Visit Blog2Video →</a>
                    </div>
                    </div>
                </TabsContent>

                {/* Event Management Platform with Infrastructure Automation */}
                <TabsContent value="eventmgmt">
                    <div className="project-card" style={{ marginTop: '20px' }}>
                    <div className="text-section">
                        <h3>Event Management Platform with Infrastructure Automation</h3>
                        <div className="project-byline">Lahore · 2025 · Terraform · Socket.io</div>
                        <p>
                        A comprehensive event management system enabling users to organize events, schedule meetings, and manage attendees with real-time updates. I integrated real-time chat support and live messaging using <span className="highlighted">Socket.io</span> to facilitate smooth communication and resolve user concerns instantly. The standout engineering effort was architecting a complete infrastructure-as-code solution with <span className="highlighted">Terraform</span> to deploy the entire system — microservices, API gateways, databases, and load balancers — with a single command. I also implemented automated database backup and restore with configurable dump schedules, plus auto-scaling and on-demand teardown to optimize cloud costs by destroying unused resources.
                        </p>
                    </div>
                    </div>
                </TabsContent>

                {/* JourniSphere */}
                <TabsContent value="Manzil">
                    <div className="project-card" style={{ marginTop: '20px' }}>
                    <div className="text-section">
                        <h3>JourniSphere — Tourist Navigation &amp; Trip Planning</h3>
                        <div className="project-byline">React Native · Node.js · PostgreSQL · 2025</div>
                        <p>
                        A comprehensive <span className="highlighted">React Native</span> tourism app for travelers in Pakistan, featuring AI-based trip planning, hotel booking, car rentals, user reviews, and real-time weather updates. I built companion web dashboards for hotel and rental management with booking analytics, and implemented secure authentication, payment-gateway integration, and location-based search with map visualization. The backend runs on <span className="highlighted">Node.js/Express</span> with a <span className="highlighted">PostgreSQL</span> database supporting concurrent users.
                        </p>

                    </div>
                    <div className="image-section">
                        <img src={manzil} alt="Ride Booking Project Snapshot" className="project-image" />
                    </div>
                    </div>
                </TabsContent>


                {/* AI-Based Task Scheduling Project */}
                <TabsContent value="taskscheduling">
                    <div className="project-card" style={{ marginTop: '20px' }}>
                    <div className="text-section">
                        <h3>AI-Powered Task Scheduling Application</h3>
                        <div className="project-byline">React Native · ChatGPT API · Firebase · Google Calendar</div>
                       <p>
                        An intelligent task management mobile app that integrates the <span className="highlighted">ChatGPT API</span> for natural-language task creation and parsing. I implemented a smart scheduling algorithm with <span className="highlighted">Google Calendar API</span> synchronization for automated meeting suggestions, breaking tasks into subtasks and automatically placing them on the calendar. A push-notification system built on <span className="highlighted">Firebase Cloud Messaging</span> delivers timely reminders and deadline alerts, while a productivity-tracking dashboard surfaces completion rates and time-management insights. Tasks move through "In Progress" and "Done" states in real time as users work.
                        </p>

                    </div>
                    <div className="image-section">
                        <img src={Task_Scheduler} alt="AI Task Scheduling Project Snapshot" className="project-image" />
                    </div>
                    </div>
                </TabsContent>

                {/* AWS Chatbot Deployment */}
                <TabsContent value="awschatbot">
                    <div className="project-card" style={{ marginTop: '20px' }}>
                    <div className="text-section">
                        <h3>AWS Chatbot Deployment with Auto-Scaling Infrastructure</h3>
                        <div className="project-byline">AWS · EC2 · S3 · CloudFront · 2023</div>
                       <p>
                        A production-ready chatbot web application providing interactive chat functionality, built and deployed on <span className="highlighted">AWS</span> cloud services (EC2, S3, CloudFront). I configured auto-scaling groups with load balancing to handle variable traffic loads and ensure high availability, implemented a <span className="highlighted">CloudFront</span> CDN for optimized static-content delivery with reduced latency, and set up S3 bucket policies for secure storage alongside an automated deployment pipeline.
                        </p>
                    </div>
                    </div>
                </TabsContent>

                </Tabs>
            </div>


            </section>


            <section id="experience" className="experience-section">
                <div className="container">
                    <div className="masthead-rule">
                        <h2 className="section-headline">Career Chronicle</h2>
                        <div className="section-kicker">A Record of Professional Service</div>
                    </div>

                    <div className="experience-grid">

                        <div className="experience-card">
                            {/* FireBirdTech */}
                            <div className="card">
                                <h3 className="company-name">FireBirdTech</h3>
                                <div className="experience-details">
                                    <strong className="role"><span>Full Stack AI Engineer (Feb 2026 – Present · Remote)</span></strong>
                                    <ul style={{ paddingLeft: '20px', margin: '20px 0' }}>
                                        <li style={{ marginBottom: '5px' }}>Engineered AI content-to-video pipelines for <a className="inline-link" href="https://blog2video.app" target="_blank" rel="noopener noreferrer">Blog2Video</a> with <span className="highlighted">DSPy</span>, running in production.</li>
                                        <li style={{ marginBottom: '5px' }}>Built dynamic video UI templates with <span className="highlighted">Remotion</span> and robust backend API workflows.</li>
                                        <li style={{ marginBottom: '5px' }}>Designed scalable system architecture for high-performance AI processing.</li>
                                        <li style={{ marginBottom: '5px' }}>Optimized rendering efficiency and customization for real end users.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="experience-card">
                            {/* Syscov */}
                            <div className="card">
                                <h3 className="company-name">Syscov</h3>

                                <div className="experience-details">
                                    <strong className="role"><span>Software Engineer (July 2025 – Feb 2026 · Lahore)</span></strong>
                                    <ul style={{ paddingLeft: '20px', margin: '20px 0' }}>
                                        <li style={{ marginBottom: '5px' }}>Built product solutions across <span className="highlighted">Django</span>, <span className="highlighted">FastAPI</span>, <span className="highlighted">React</span>, <span className="highlighted">Terraform</span>, and <span className="highlighted">Azure</span>.</li>
                                        <li style={{ marginBottom: '5px' }}>Worked directly with clients to architect tailored technical solutions.</li>
                                        <li style={{ marginBottom: '5px' }}>Integrated secure backends with <span className="highlighted">PostgreSQL</span> and <span className="highlighted">MongoDB</span>.</li>
                                        <li style={{ marginBottom: '5px' }}>Contributed to system design, sprint planning, and code reviews.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div className="experience-card">
                            {/* Experience card with company name */}
                            <div className="card">
                                <h3 className="company-name">
                                    SnackOut Technologies
                                    <img src={SnackOutLogo} alt="SnackOut logo" className="company-logo-inline" />
                                </h3>
                                <div className="experience-details">
                                    <strong className="role"><span>Associate Software Engineer · Part Time (Jan 2025 – June 2025)</span></strong>
                                    <ul style={{ paddingLeft: '20px', margin: '20px 0' }}>
                                        <li style={{ marginBottom: '5px' }}> Led frontend of the Vendor and Admin web panels using <span className="highlighted">React</span> and <span className="highlighted">TypeScript</span>.</li>
                                        <li style={{ marginBottom: '5px' }}> Built order, inventory, and wallet modules on a <span className="highlighted">Node.js</span>/<span className="highlighted">PostgreSQL</span> backend with Firebase &amp; Kafka.</li>
                                        <li style={{ marginBottom: '5px' }}> Integrated push notifications via <span className="highlighted">Firebase</span> for real-time vendor and rider updates.</li>
                                        <li style={{ marginBottom: '5px' }}> Owned end-to-end feature delivery, ensuring performance and scalability.</li>
                                    </ul>

                                </div>
                            </div>
                            
                        </div>

                        <div className="experience-card">
                            {/* Experience card with company name */}
                            <div className="card">
                                <h3 className="company-name">
                                    <span style={{color: "#d8d3d3"}}>SIGMA</span>
                                    <span style={{color: "#770909"}}>TEC</span><span style={{color: "#d8d3d3"}}> Solutions</span>
                                </h3>

                                <div className="experience-details">
                                    <strong className="role"><span style={{color: "#d8d3d3"}}>Software Development Intern (June-August 2023)</span></strong>
                                    <ul style={{ paddingLeft: '20px', margin: '20px 0' }}>
                                        <li style={{ marginBottom: '5px' }}> Built a photography portfolio website using the <span className="highlighted">MERN</span> stack.</li>
                                        <li style={{ marginBottom: '5px' }}> Refined the UI with the design team and ran user testing to improve functionality.</li>
                                        <li style={{ marginBottom: '5px' }}> Gained hands-on experience across the full MERN development lifecycle.</li>
                                        <li style={{ marginBottom: '5px' }}> Implemented feedback-driven improvements that boosted engagement.</li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>

                    </div>
                </div>
            </section>


            <AnimatedSkills />

{/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
       
            <section id="contact" className="contact-section">
                <div className="container">
                    <div className="masthead-rule">
                        <h2 className="section-headline">Letters to the Editor</h2>
                        <div className="section-kicker">Correspondence Welcome · Write In Below</div>
                    </div>
                    <div className="contact-grid">
                    <div className="contact-form">
                        <h2>Send a Dispatch</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Name:</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email:</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="message">Message:</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="submit-button">Send Message</button>
                        </form>
                    </div>


                        <div className="contact-info">
                            <h2>The Newsroom</h2>
                            <p>Feel free to reach out through the form or connect with me on social media. Story tips, collaborations, and opportunities all welcome.</p>
                            <div className="social-icons">
                                <a href="https://www.linkedin.com/in/muhammad-mehdi-07a716255" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                                <a href="https://github.com/Muhammad-Mehdi-Changazi" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-github"></i>
                                </a>
                                <a href="https://www.instagram.com/mehdi_changezii" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram"></i>
                                </a>
                                
                                <a href="https://www.facebook.com/mehdichangexii?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook"></i>
                                </a>
                            </div>

                            <div className="contact-icons" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <a href="mailto:Mehdichangazi135@gmail.com" style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginLeft:"0px" }}>
                                    <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                    MehdiChangazi135@gmail.com
                                </a>
                                <a href="tel:+923418886424" style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginLeft:"0px" }}>
                                    <i className="fas fa-phone" style={{ marginRight: '5px' }}></i>
                                    +92 341 888 6424
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

{/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
          
          
            <footer className="footer-section">
                <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', padding: '0 30px' }}>
                    <div className="footer-right">
                        <h3 lang="ur" dir="rtl">— ۳۰ — · جملہ حقوق محفوظ ہیں © {new Date().getFullYear()} دی مہدی ٹائمز · لاہور میں طبع ہوا</h3>
                    </div>
                </div>
            </footer>

        {/* Classical sub-continental background music (sitar/tabla).
            Drop an audio file at client/public/classical-subcontinent.mp3.
            Autoplay is blocked by browsers, so playback starts on the toggle. */}
        <audio ref={audioRef} src={`${process.env.PUBLIC_URL}/classical-subcontinent.mp3`} loop preload="auto" />

        <button
            type="button"
            className={`music-toggle ${musicOn ? 'is-playing' : ''}`}
            onClick={toggleMusic}
            title={musicOn ? 'Pause music' : 'Play classical music'}
            aria-label={musicOn ? 'Pause music' : 'Play classical music'}
        >
            <i className={`fas ${musicOn ? 'fa-music' : 'fa-play'}`}></i>
            <span>{musicOn ? 'Now Playing' : 'Play Raag'}</span>
        </button>

        <ToastContainer />
        </>


    );

    
};

export default MainPage;
